import { createSlice } from "@reduxjs/toolkit";

export const INITIAL_STATE = {
  stale: false,
  isLoading: false,
};

const samGovIngestStatusSlice = createSlice({
  name: "samGovIngestStatus",
  initialState: INITIAL_STATE,
  reducers: {
    reset() {
      return INITIAL_STATE;
    },
    setSamGovDataStale(state, { payload }) {
      state.stale = Boolean(payload);
    },
    setSamGovIngestStatusLoading(state, { payload }) {
      state.isLoading = payload;
    },
  },
});

export const { reset, setSamGovDataStale, setSamGovIngestStatusLoading } =
  samGovIngestStatusSlice.actions;

export default samGovIngestStatusSlice;
